import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "aria-hidden": "true",
  ref: "modalRemove"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fs-5" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode("Eliminando: ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.classInfo.title), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" ¿Estas seguro de eliminar la clase ", -1)),
            _createElementVNode("b", null, "\"" + _toDisplayString(_ctx.classInfo.title) + "\"", 1),
            _cache[4] || (_cache[4] = _createTextVNode(" del dia ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.translateDay(_ctx.classInfo.weekDay)), 1),
            _cache[5] || (_cache[5] = _createTextVNode(" a las ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.classInfo.time), 1),
            _cache[6] || (_cache[6] = _createTextVNode("? ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, "Cancelar", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteClass()))
          }, "Eliminar")
        ])
      ])
    ])
  ], 512))
}